import { Button, DatePicker, Row } from 'antd';
import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
	DEFAULT_START_DATES,
	getDefaultDateRanges,
	getStandardDateRange,
} from '../../utils/DataFormatterUtils';
import moment from 'moment';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';

const RANGE_PICKER_DATE_FORMAT = 'MM-DD-YYYY';

const DashboardDateRangePicker: FC<any> = ({
	value,
	onChange,
	ranges = getDefaultDateRanges(),
	disabledDate = () => {},
}): React.ReactElement => {
	const startDate = useMemo(() => value && value.length > 0 && value[0], [value]);
	const endDate = useMemo(() => value && value.length > 1 && value[1], [value]);
	const [showDatePicker, setShowDatePicker] = useState(false);
	const [dates, setDates] = useState(value);
	const calendar = useRef(null);

	const isSameDay = (date1, date2) =>
		moment(date1).endOf('day').diff(moment(date2).endOf('day')) === 0;
	const getStandardDateRange = (startDate, endDate, ranges) => {
		if (
			Object.values(ranges).some((value) => isSameDay(value[0], startDate)) &&
			isSameDay(moment(), endDate)
		) {
			return `In the ${Object.keys(ranges)
				.find((key) => {
					const values = ranges[key];
					return (
						values &&
						values[0] &&
						isSameDay(values[0], startDate) &&
						values[1] &&
						isSameDay(values[1], endDate)
					);
				})
				.toLowerCase()}`;
		} else {
			return `Between ${startDate.format('MMMM D, YYYY')} and ${endDate.format('MMMM D, YYYY')}`;
		}
	};
	useEffect(() => {
		if (calendar.current && showDatePicker) {
			calendar.current.focus();
		}
	}, [showDatePicker]);
	return (
		<span>
			<span
				className="truncate"
				style={{
					color: 'rgba(0, 0, 0, 0.85)',
					letterSpacing: '0.5px',
					fontSize: '17px',
					fontWeight: 400,
					marginLeft: 16,
					marginBottom: 10,
				}}
			>
				{getStandardDateRange(moment(startDate), moment(endDate), ranges)}
			</span>

			{showDatePicker ? (
				<span className={'ml-3'} style={{ marginRight: 12 }}>
					<DatePicker.RangePicker
						visible={showDatePicker}
						key={
							startDate && endDate
								? startDate.format('YYMMDD') + endDate.format('YYMMDD')
								: undefined
						}
						value={dates}
						ranges={ranges}
						format={RANGE_PICKER_DATE_FORMAT}
						showTime={false}
						onChange={(values) => {
							setDates(values);
							if (values.length === 2) {
								onChange(values);
								setShowDatePicker(false);
							}
						}}
						allowEmpty={[false, false]}
						disabledDate={disabledDate}
						open={showDatePicker}
						ref={calendar}
					/>
				</span>
			) : (
				<Button
					style={{ marginTop: -12 }}
					type={'link'}
					onClick={() => {
						setShowDatePicker(true);
						setDates([]);
						if (calendar.current) {
							calendar.current.focus();
						}
					}}
				>
					<span style={{ fontSize: 16 }}>
						<i className="icons8-font icons8-schedule mr-1" />
					</span>
				</Button>
			)}
		</span>
	);
};

export default DashboardDateRangePicker;
